// extracted by mini-css-extract-plugin
module.exports = {"text-block":"next-contact-us-block_text-block__bEBB3","icon":"next-contact-us-block_icon__Xv1ZF","icon__border":"next-contact-us-block_icon__border__3BJqN"};